import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { OryConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [],
})
export class OryApiModule {
  public static forRoot(configurationFactory: () => OryConfiguration): ModuleWithProviders<OryApiModule> {
    return {
      ngModule: OryApiModule,
      providers: [{ provide: OryConfiguration, useFactory: configurationFactory }],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: OryApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('OryApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
